<template>
    <section>
        <section class="responsibleContainer">
            <section class="workshiftHeader">
                <span>{{ this.headers.length > 0 ? this.headers[0] : this.$t('turnA') }}</span>
                <section class="workshiftcontainer">
                    <label for="workshiftA">
                        <p>{{ this.$t('main-responsible') }}</p>
                        <select id="workshiftA" v-model="processObj.workshiftAResponsibles.mainResponsibleId">
                            <option v-for="(item, idx) in responsibleList" :key="idx + 'workshiftA'" :value="item">
                                {{ item.name }}
                            </option>
                        </select>
                    </label>
                    <section class="respAux">
                        <section>
                            <label for="auxworkshiftA">
                                <p>{{ this.$t('aux-responsible') }}</p>
                                <select id="auxworkshiftA" v-model="currentAuxASelected">
                                    <option v-for="(item, idx) in responsibleList" :key="idx + 'auxWorkshiftA'"
                                        :value="item">
                                        {{ item.name }}
                                    </option>
                                </select>
                            </label>
                            <button @click="addAuxResp('workshiftAResponsibles', currentAuxASelected)">
                                <b-icon-plus></b-icon-plus>
                            </button>
                        </section>
                        <section>
                            <span v-for="(aux, auxIdx) in processObj.workshiftAResponsibles.auxResponsiblesId"
                                :key="auxIdx + 'auxA'">
                                {{ aux.name }}
                                <button @click="deleteAuxResp('workshiftAResponsibles', aux)">
                                    <b-icon-trash-fill></b-icon-trash-fill>
                                </button>
                            </span>
                        </section>
                    </section>
                </section>
            </section>
            <section class="workshiftHeader">
                <span>{{ this.headers.length > 0 ? this.headers[1] :  this.$t('turnB') }}</span>
                <section class="workshiftcontainer">
                    <label for="workshiftB">
                        <p>{{ this.$t('main-responsible') }}</p>
                        <select id="workshiftB" v-model="processObj.workshiftBResponsibles.mainResponsibleId">
                            <option v-for="(item, idx) in responsibleList" :key="idx + 'workshiftB'" :value="item">
                                {{ item.name }}
                            </option>
                        </select>
                    </label>
                    <section class="respAux">
                        <section>
                            <label for="auxworkshiftB">
                                <p>{{ this.$t('aux-responsible') }}</p>
                                <select id="auxworkshiftB" v-model="currentAuxBSelected">
                                    <option v-for="(item, idx) in responsibleList" :key="idx + 'auxWorkshiftB'"
                                        :value="item">
                                        {{ item.name }}
                                    </option>
                                </select>
                            </label>
                            <button @click="addAuxResp('workshiftBResponsibles', currentAuxBSelected)">
                                <b-icon-plus></b-icon-plus>
                            </button>
                        </section>
                        <section>
                            <span v-for="(auxb, auxbIdx) in this.processObj.workshiftBResponsibles.auxResponsiblesId"
                                :key="auxbIdx + 'auxB'">
                                {{ auxb.name }}
                                <button @click="deleteAuxResp('workshiftBResponsibles', auxb)">
                                    <b-icon-trash-fill></b-icon-trash-fill>
                                </button></span>
                        </section>
                    </section>
                </section>
            </section>
            <section class="workshiftHeader">
                <span>{{ this.headers.length > 0 ? this.headers[2] :  this.$t('turnC') }}</span>
                <section class="workshiftcontainer">
                    <label for="workshiftC">
                        <p>{{ this.$t('main-responsible') }}</p>
                        <select id="workshiftC" v-model="processObj.workshiftCResponsibles.mainResponsibleId">
                            <option v-for="(item, idx) in responsibleList" :key="idx + 'workshiftC'" :value="item">
                                {{ item.name }}
                            </option>
                        </select>
                    </label>
    
                    <section class="respAux">
                        <section>
                            <label for="">
                                <p>{{ this.$t('aux-responsible') }}</p>
                                <select id="auxworkshiftC" v-model="currentAuxCSelected">
                                    <option v-for="(item, idx) in responsibleList" :key="idx + 'auxWorkshiftC'"
                                        :value="item">
                                        {{ item.name }}
                                    </option>
                                </select>
                            </label>
                            <button @click="addAuxResp('workshiftCResponsibles', currentAuxCSelected)">
                                <b-icon-plus></b-icon-plus>
                            </button>
                        </section>
                        <section>
                            <span v-for="(auxC, auxCIdx) in processObj.workshiftCResponsibles.auxResponsiblesId"
                                :key="auxCIdx + 'auxC'">
                                {{ auxC.name }}
                                <button @click="deleteAuxResp('workshiftCResponsibles', auxC)">
                                    <b-icon-trash-fill></b-icon-trash-fill>
                                </button>
                            </span>
                        </section>
                    </section>
                </section>
            </section>
    
        </section>
        <section class="applyButtons">
            <b-button variant="danger" @click="restoreProcess">{{ this.$t('cancelar') }}</b-button>
            <b-button variant="info" @click="applyProcess">{{ this.$t('salvar') }}</b-button>
        </section>
    </section>
</template>
<script>
export default {
    name: 'ResponsiblesModal',
    props: ['processObj', 'responsibleList', 'cancelFunc', 'saveFunc', 'workshiftNames'],

    data() {
        return {
            currentProcess: {},

            backupProcess:{},

            currentAuxASelected: 0,
            currentAuxBSelected: 0,
            currentAuxCSelected: 0,

            headers:[]
        }
    },

    watch: {
        "processObj.workshiftAResponsibles.mainResponsibleId"() {
            this.processObj.workshiftAMainResponsible = this.processObj.workshiftAResponsibles.mainResponsibleId.name
        },
        "processObj.workshiftBResponsibles.mainResponsibleId"() {
            this.processObj.workshiftBMainResponsible = this.processObj.workshiftBResponsibles.mainResponsibleId.name
        },
        "processObj.workshiftCResponsibles.mainResponsibleId"() {
            this.processObj.workshiftCMainResponsible = this.processObj.workshiftCResponsibles.mainResponsibleId.name
        }
    },

    methods: {
        addAuxResp(workshiftname, resp) {
            let respArr = [...this.processObj[`${workshiftname}`].auxResponsiblesId];

            if (respArr.some(item => resp.id === item.id) || resp == 0) {
                return;
            }

            respArr.push(resp)

            this.processObj[`${workshiftname}`].auxResponsiblesId = [...respArr]
        },

        deleteAuxResp(workshiftname, resp){
            let respArr = [...this.processObj[`${workshiftname}`].auxResponsiblesId];
            respArr = respArr.filter(item => item.id != resp.id);
            this.processObj[`${workshiftname}`].auxResponsiblesId = [...respArr]
        },

        applyProcess() {
            if (!this.processObj.workshiftAResponsibles.mainResponsibleId || !this.processObj.workshiftBResponsibles.mainResponsibleId || !this.processObj.workshiftCResponsibles.mainResponsibleId 
            || this.processObj.workshiftAResponsibles.mainResponsibleId.name == "" || this.processObj.workshiftBResponsibles.mainResponsibleId.name == "" || this.processObj.workshiftCResponsibles.mainResponsibleId.name == "") {
                this.$bvToast.toast("Selecione os responsáveis principais antes de prosseguir.", {
                    title: "Responsável Principal Obrigatório",
                    variant: "warning",
                    toaster: 'b-toaster-bottom-left',
                    solid: true
                })

                return;
            }else {
                this.saveFunc()
            }
        },

        restoreProcess(){
            Object.assign(this.processObj, this.backupProcess)
             
            this.cancelFunc();
        }
    },

    mounted(){
        this.backupProcess = JSON.parse(JSON.stringify(this.processObj));

        this.workshiftNames.forEach(item => {
            if(item.key == "workshiftAMainResponsible"){
                this.headers.unshift(item.label);
            }else if(item.key == "workshiftBMainResponsible"){
                this.headers.push(item.label);

            }else if(item.key == "workshiftCMainResponsible"){
                this.headers.push(item.label);

            }
        })
    }
}
</script>
<style scoped>
.responsibleContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 1rem;
}

.workshiftHeader {
    width: 100%;
}


.workshiftHeader span {
    display: flex;
    flex-direction: column;

    background-color: #5AAEAC;
    border: 1px solid #14A39F;
    border-radius: 0.2rem;
    padding: 0.3rem;
    font-weight: bold;
    text-align: center;
    color: white;
    margin-bottom: 0.4rem;
}

label {
    width: 100%;
    position: relative;
    margin: 1rem 0;
}

select {
    width: 100%;
    padding: 0.5rem 0.5rem;
    border: 1px solid #FF5F00;
    border-radius: 0.2rem;
}

label p {
    position: absolute;
    top: -.8rem;
    left: 0.4rem;
    background-color: white;
    font-size: 0.8rem;
    color: #FF5F00;
    padding-left: 0.3rem;
    padding-right: 0.5rem;
    font-weight: 500;
}

.respAux {
    width: 100%;
}

.respAux label {
    width: 100%;
}

.respAux section:first-child {
    display: flex;
    flex-direction: row !important;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    column-gap: 0.2rem;
}


.respAux section:last-child {
    border: 1px solid gray;
    height: 12rem;
    border-radius: 0.2rem;
    max-height: 12rem;
    overflow-y: auto;
}

.respAux span {
    font-weight: normal;
    color: black;
    background-color: transparent !important;
    border: none;
    border-radius: 0;
    text-align: left;
    border-bottom: 1px solid gray;

    padding: 0.3rem 0.5rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.respAux button {
    background-color: #FF5F00;
    border: none;
    border-radius: 0.2rem;
    color: white;
    font-weight: bold;
    font-size: 1.2rem;
    height: max-content;
    padding: 0.3rem;
    cursor: pointer;
}

.respAux span button {
    background-color: red;
    font-size: 1rem;
}

.applyButtons{
    margin-top: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    column-gap: 1rem;
}

.applyButtons button{
    cursor: pointer;
    
}
</style>